import { observer } from 'mobx-react';
const CssHighlightElement = observer(({
  htmlElement
}) => {
  //console.log(htmlElement)
  //const { left, top, width, height } = getElementAbsoluteCoords(htmlElement)

  return '';
  // return (
  //     <>
  //         <div className='css-highlight-single-element' style={{
  //             left: `${left - 2 - 5}px`,
  //             top: `${top - 2 - 5}px`,
  //             width: `${width + 10}px`,
  //             height: `${height + 10}px`
  //         }}/>
  //     </>
  // );
});

export default CssHighlightElement;